import { HelpPanel, Link } from '@amzn/awsui-components-react';
import { externalLinks } from '../../data/externalLinks';
import { useLocalizedText } from '../../hooks/localizedText';

const I18N = 'nonProfitSearch.help';

/**
 * The "Non-profit search" help panel, shown in the AppLayout tools slot and opened by the Info link
 * beside the page heading. Mirrors the codebase's *HelpPanel pattern, with the outbound link in the
 * footer slot as CoordinatorNotificationHelpPanel does.
 */
export function NonProfitSearchHelpPanel() {
  const { t } = useLocalizedText(['nonprofits', 'translation']);
  return (
    <HelpPanel
      header={<h2>{t(`${I18N}.title`)}</h2>}
      footer={
        <Link
          href={externalLinks.volunteeringGrants}
          external
          data-aci-analytics-name="nonProfitSearch_grantsLinkClicked"
          data-aci-analytics-value="Volunteering Grants Wiki"
        >
          {t(`${I18N}.grants.learnMore`)}
        </Link>
      }
    >
      <p>{t(`${I18N}.intro`)}</p>

      <h3>{t(`${I18N}.findHere.title`)}</h3>
      <p>{t(`${I18N}.findHere.body`)}</p>

      <h3>{t(`${I18N}.howItWorks.title`)}</h3>
      <ol>
        <li>{t(`${I18N}.howItWorks.step1`)}</li>
        <li>{t(`${I18N}.howItWorks.step2`)}</li>
        <li>{t(`${I18N}.howItWorks.step3`)}</li>
      </ol>

      <h3>{t(`${I18N}.grants.title`)}</h3>
      <p>{t(`${I18N}.grants.intro`)}</p>
      <ul>
        <li>{t(`${I18N}.grants.excluded.sponsorships`)}</li>
        <li>{t(`${I18N}.grants.excluded.marketing`)}</li>
        <li>{t(`${I18N}.grants.excluded.swag`)}</li>
        <li>{t(`${I18N}.grants.excluded.meetingRooms`)}</li>
        <li>{t(`${I18N}.grants.excluded.forProfit`)}</li>
        <li>{t(`${I18N}.grants.excluded.donations`)}</li>
      </ul>
    </HelpPanel>
  );
}
